import React from "react";
import { Route, Redirect } from "react-router-dom";

const LoginLayout = ({ children }) => <div>{children}</div>;

const LoginLayoutRoute = ({ component: Component, ...rest }) => {
  if (sessionStorage.userInfo) return <Redirect to={{ pathname: "/main" }} />;

  return (
    <Route
      {...rest}
      render={(props) => (
        <LoginLayout>
          <Component {...props} />
        </LoginLayout>
      )}
    />
  );
};

export default LoginLayoutRoute;
